import {FC} from 'react'
import VariantListItem from './VariantListItem'

type Props = {
  products: Array<any>
}

const ProductList: FC<Props> = ({products}) => {
  if (products.length === 0) {
    return (
      <div className='my-5 d-flex justify-content-center'>
        No products found with available inventory.
      </div>
    )
  }
  return (
    <div className='pt-3'>
      {products.map((product, index) => {
        return (
          <div key={index}>
            {product.variants.nodes.length > 0 &&
              product.variants.nodes.map((variant: any, index: number) => (
                <VariantListItem key={index} variant={variant} product={product} />
              ))}
          </div>
        )
      })}
    </div>
  )
}

export default ProductList
